const baseUrl = 'http://117.247.95.159/v1'
// const baseUrl = 'http://localhost:4002/v1'

export default baseUrl
